import { twClassMerge } from '@healthhub/react-ui';
import type { PropsWithChildren } from 'react';

import { useLayoutViewContext } from '@shared/context';

interface Props {
  className?: string;
}

const MobileStickyFooter = ({ children, className }: PropsWithChildren<Props>) => {
  const { isMobileView, isSharedServiceView, isStandardView } = useLayoutViewContext();

  return (
    <div
      className={twClassMerge({
        'z-sticky fixed bottom-0 left-0 right-0 bg-primary-grey px-4 py-6 shadow-[0px_-1px_12px_0px_rgba(0,0,0,0.25)]':
          isMobileView,
        [className as string]: !!className,
        'px-4 py-6': isSharedServiceView || isStandardView,
      })}
    >
      {children}
    </div>
  );
};

export default MobileStickyFooter;
